import { Dropdown, Option, mergeClasses } from '@fluentui/react-components';
import { actionRelationshipInputStyles } from './styles';
import { useAutomationRuleActions } from 'src/pages/automation-rule/form/actions/use-actions';
import { ActionItemType } from 'src/pages/automation-rule/form/actions/types';
import { useMemo } from 'react';

interface Props {
	actionId: string;
	onOptionSelect: (value: string) => void;
}

const relationshipOptions = [
	{
		label: 'This work item',
		value: 'this-work-item',
	},
	{
		label: 'Parent work item',
		value: 'parent-work-item',
	},
	{
		label: 'Children work items',
		value: 'children-work-items',
	},
	{
		label: 'Sibling work items',
		value: 'sibling-work-items',
	}
];

export default function ActionRelationshipInput(props: Props) {
	const classes = actionRelationshipInputStyles();
	const {actions} = useAutomationRuleActions();

	const currentValue = useMemo(() => {
		const found = actions.find(action => action.id === props.actionId) as ActionItemType;

		if (found.addCommentToWorkItem) {
			return relationshipOptions.find(item => item.value === found.addCommentToWorkItem!.relationship)?.value || '';
		}

		if (found.editWorkItem) {
			return relationshipOptions.find(item => item.value === found.editWorkItem!.relationship)?.value || '';
		}

		return '';
	}, [actions, props.actionId]);

	const value = useMemo(() => {
		const found = actions.find(action => action.id === props.actionId) as ActionItemType;

		if (found.addCommentToWorkItem) {
			return relationshipOptions.find(item => item.value === found.addCommentToWorkItem!.relationship)?.label || '';
		}

		if (found.editWorkItem) {
			return relationshipOptions.find(item => item.value === found.editWorkItem!.relationship)?.label || '';
		}

		return '';
	}, [actions, props.actionId]);
  
	return (
		<>
			<Dropdown
				className={mergeClasses(
					classes.dropdown,
					classes.conditionTypeDropdown,
				)}
				listbox={{
					style: {
						minWidth: 'fit-content'
					}
				}}
				appearance='underline'
				placeholder='Relationship'
				positioning="below-start"
				value={value}
				selectedOptions={currentValue ? [currentValue] : []}
				onOptionSelect={(_, data) => {
					props.onOptionSelect(data.optionValue as string);
				}}
			>
				{relationshipOptions.map((option) => (
					<Option key={option.value} value={option.value}>{option.label}</Option>
				))}
			</Dropdown>
		</>
	);
}